import { combineReducers } from 'redux';

import CursorCoordinatesReducer from './CursorCoordinatesReducer';
import CursorShapeReducer from './CursorShapeReducer';

export default combineReducers({
  CursorCoordinatesReducer,
  CursorShapeReducer,
});
